import './PositionsSkeleton.scss';

const PositionsSkeleton = () => {

    return (
        <>
            <div className='careers__positions__section__skeleton'>
                <div className='left__side__positions__section__skeleton'>
                    <div className='positions__content__skeleton'>
                        <div className='positions__accent__skeleton'></div>
                        {[...Array(2)].map((_, index) => (
                            <div key={index} className='positions__title__skeleton'></div>
                        ))}
                        <div className='positions__title__skeleton--primary'></div>
                        {[...Array(5)].map((_, index) => (
                            <div key={index} className='positions__subtitle__skeleton'></div>
                        ))}
                        <div className='positions__subtitle__skeleton--primary'></div>
                    </div>
                </div>
                <div className='right__side__positions__section__skeleton'>
                    <div className='positions__accent__skeleton'></div>
                    <div className="pos__list__section__skeleton">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="pos__list__question__skeleton">
                                <div className='pos__list__title__skeleton'></div>
                                <span className="pos__list__arrow__skeleton"></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PositionsSkeleton;